import { useEffect, useState } from 'preact/hooks';

let show;

export function Toast() {
  const [msg, setMsg] = useState('');
  useEffect(() => {
    show = (m, ms = 2500) => {
      setMsg(m);
      setTimeout(() => setMsg(''), ms);
    };
  }, []);
  return msg ? <div class="toast">{msg}</div> : null;
}

export const toast = (m, ms) => show && show(m, ms);
